import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import MenuFooter from './MenuFooterComponent';
import Frequencys from '../../../common/frequency/buttonFrequencys';
// import Breadcrumbs from '../../../common/Breadcrumbs/Breadcrumbs';
// import Button from '../../../common/button/Button';

// const appsIcon = '/imgAplicativosPage/all-apps-button-2x.png';
// const seloVerdeMini = '/ecolmeia-selo-ouro_mini.png';
// const seloVerdeFull = '/ecolmeia-selo-ouro_full.jpg';
const footerList = [
    {
        category: 'Antena 1',
        items: [
            { title: 'Sobre a rádio', to: '/quem-somos' },
            { title: 'Notícias', to: '/noticias' },
            { title: 'Promoções', to: '/promocoes' },
            // { title: 'Jornalistas', to: '/jornalistas' },
            { title: 'Afiliadas', to: '/afiliadas' },
            { title: 'Clientes', to: '/clientes' },
            { title: 'Contato', to: '/contato' },
            { title: 'Trabalhe conosco', to: '/trabalhe-conosco' },
            // { title: 'Anuncie conosco', to: '/anuncie-conosco' },
        ],
    },
    {
        category: 'Música',
        items: [
            { title: 'Ouvir rádio online', to: '/ouvir-radio-online' },
            { title: 'Programação', to: '/programacao' },
            { title: 'Antena 1 TV', to: '/tv' },
            { title: 'Artistas', to: '/artistas' },
            { title: 'Músicas', to: '/musicas' },
            { title: 'As 10+', to: '/as-10-mais' },
            { title: 'As 100+', to: '/as-100-mais' },
            // { title: 'Vídeos', to: '/videos' },
        ],
    },
    {
        category: 'Mais',
        items: [
            { title: 'Parceiros', to: '/parceiros' },
            { title: 'Antenna1 Roma', to: 'http://www.antenna1.fm/', externalLink: 'true' },
            { title: 'Sitemap', to: '/sitemap' },
            { title: 'Sucuri', to: 'https://monitor19.sucuri.net/m/verify/?r=32fa4816e361f92ae9e9a1bf9bd42b6abf3d3a7455', externalLink: 'true' },
            { title: 'Sectigo', to: 'https://www.trustlogo.com/ttb_searcher/trustlogo?v_querytype=W&v_shortname=SECOV&v_search=https://www.antena1.com.br&x=6&y=5', externalLink: 'true' },
            { title: 'Feeds (RSS, Atom)', to: '/feeds' },
            { title: 'Política de privacidade', to: '/termos/privacidade' },
            { title: 'Termos de uso', to: '/termos/uso' },
        ],
    },
    /*
    // {
        // category: 'Interativo',
        // items: [
        // ],
        // },
        // {
        // category: 'Social Antena 1',
        // Note: the icons are commented out because the YouTube Brand Guidelines say, that the icon must be at minimum 20px in height
        // and the icons are not that big. So I commented them out for now. (Also believing, that there will be a remake of the complete layout soon)
        //items: [
        //    { title: 'Facebook', to: 'https://www.facebook.com/Antena1.BR', faIcon: faFacebookF, externalLink: 'true' },
        //    { title: 'Twitter', to: 'https://twitter.com/Antena_1', faIcon: faTwitter, externalLink: 'true' },
        //    { title: 'Instagram', to: 'https://www.instagram.com/antena1/', faIcon: faInstagram, externalLink: 'true' },
        //    { title: 'YouTube', to: 'http://www.youtube.com/Antena1Brasil', faIcon: faYoutube, externalLink: 'true' },
        //    { title: 'Vk Brasil', to: 'https://vk.com/antena1', faIcon: faVk, externalLink: 'true' },
        // ],
    //},
     {
        category: 'Download',
        items: [
            { title: 'Mandalas', to: '/#' },
            { title: 'Wallpapers', to: '/#' },
            { title: 'Caricaturas', to: '/#' },
            { title: 'Capas', to: '/#' },
            { title: 'Loja Virtual', to: '/#' },
        ],
    }, */
];

// const urlLocation = window.location;

const footerAvailablePlatforms = [
    {
        icon: 'google_assistant.svg',
        link: '#',
        title: 'Baixe agora no Google Assistant',
    },
    {
        icon: 'amazon_alexa.svg',
        link: 'https://www.amazon.com.br/Antena-1-Um/dp/B07XJ28V8Q/',
        title: 'Baixe agora na Amazon Alexa',
    },
    {
        icon: 'google_play.svg',
        link: 'https://play.google.com/store/apps/details?id=br.com.mobits.antena1',
        title: 'Baixe agora no Google Play',
    },
    {
        icon: 'app_store.svg',
        link: 'https://apps.apple.com/br/app/r%C3%A1dio-antena-1/id378370013',
        title: 'Baixe agora na APP Store',
    },
    {
        icon: 'lg.svg',
        link: '/noticias/app-antena-1-como-instalar-na-sua-tv-lg',
        title: 'Baixe agora na LG',
    },
    {
        icon: 'samsung.svg',
        link: '/noticias/app-antena-1-como-instalar-na-sua-tv-samsung',
        title: 'Baixe agora na Samsung',
    },
    {
        icon: 'apple_tv.svg',
        link: '/noticias/app-antena-1-como-instalar-na-sua-apple-tv',
        title: 'Baixe agora na Apple TV',
    },
    {
        icon: 'fire_tv.svg',
        link: 'https://www.amazon.com.br/Antena-1/dp/B07V2NVTBW',
        title: 'Baixe agora na Fire TV',
    },
    {
        icon: 'roku.svg',
        link: 'https://channelstore.roku.com/pt-br/details/282c04219d25238fd79f9951c27865c0:cb1f3a198ef0073eb57e30f099c237c0/antena-1',
        title: 'Baixe agora no Roku',
    },

]

// Does not use `this` (no component state/props involved), kept outside the class as a plain function.
const handlingDom = (element) => {
    if (window.innerWidth >= 992) {
        return;
    }

    const menuList = element.nextElementSibling; // Use nextElementSibling para precisão
    const iconCollapsed = element.querySelector('.icon-collapsed');
    const iconExpanded = element.querySelector('.icon-expanded');

    const isExpanded = menuList.classList.contains('slideInDown');

    if (!isExpanded) {
        menuList.classList.remove('slideOutUp');

        menuList.classList.add('slideInDown');

        iconCollapsed.classList.add('hidden');

        iconExpanded.classList.remove('hidden');
    } else {
        menuList.classList.remove('slideInDown');

        menuList.classList.add('slideOutUp');

        iconCollapsed.classList.remove('hidden');

        iconExpanded.classList.add('hidden');
    }
};

// Does not use `this`, kept outside the class as a plain function.
const handleNavigate = () => {
    document.body.scrollTop = 0; // For Safari

    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
};

class Footer extends Component {
    // constructor(props) {
    //     super(props);

    //     this.state = {
    //         ecolmeiaFull: false,
    //     };
    // }

    componentDidMount() {
        const itemMenu = document.querySelectorAll('.item-menu-header');

        for (let i = 0; i < itemMenu.length; i += 1) {
            // For all major browsers, except IE 8 and earlier
            if (itemMenu[i].addEventListener) {
                itemMenu[i].addEventListener('click', handlingDom.bind(null, itemMenu[i]));

                // For IE 8 and earlier versions
            } else if (itemMenu[i].attachEvent) {
                itemMenu[i].attachEvent('onclick', handlingDom.bind(null, itemMenu[i]));
            }
        }
    }

    // _ecolmeiaMouseOver = (event) => {
    //     if (event.type === 'mouseenter') {
    //         this.setState({
    //             ecolmeiaFull: true,
    //         });
    //     } else if (event.type === 'mouseleave') {
    //         this.setState({
    //             ecolmeiaFull: false,
    //         });
    //     }
    // }


    // The following is working more or less, but it adds complexity and additional time to loading
    // So I am now only using the verification link that is generated by this script
    // keeping it here in case we need it again one day (it was in didMount)
    /*     _mountComodo = () => {
        const comodo = document.getElementById('comodo');
        const isLocalhost = window.location.host === 'localhost' || window.location.host === 'localhost:3000';
        const domain = 'https://www.antena1.com.br';
        const trustHostName = isLocalhost ? 'http://www.trustlogo.com/' : 'https://secure.comodo.com/';
        let content = '';

        content += `<a href="javascript:if(window.open('${trustHostName}ttb_searcher/trustlogo?v_querytype=W&amp;v_shortname=CL1&amp;v_search=${domain}&amp;x=6&amp;y=5','tl_wnd_credentials'+(new Date()).getTime(),'toolbar=0,scrollbars=1,location=1,status=1,menubar=1,resizable=1,width=374,height=660,left=60,top=120')){};tLlB(tLTB);" onmouseover="tLeB(event,'${trustHostName}ttb_searcher/trustlogo?v_querytype=C&amp;v_shortname=CL1&amp;v_search=${domain}&amp;x=6&amp;y=5','tl_popupCL1')" onmousemove="tLXB(event)" onmouseout="tLTC('tl_popupCL1')" ondragstart="return false;">`;

        content += `<img src="/sectigo_trust_seal_lg_140x54.png" alt="Selo de segurança Sectigo" border="0" onmousedown="return tLKB(event,'${trustHostName}ttb_searcher/trustlogo?v_querytype=W&amp;v_shortname=CL1&amp;v_search=${domain}&amp;x=6&amp;y=5');" oncontextmenu="return tLLB(event);">`;

        content += '</a>';

        content += '<div id="tl_popupCL1" name="tl_popupCL1" style="position: absolute; z-index: 0; visibility: hidden; background-color: transparent; overflow: hidden; border-width: 0px;" onmouseover="tLoB(\'tl_popupCL1\')" onmousemove="tLpC(\'tl_popupCL1\')" onmouseout="tLpB(\'tl_popupCL1\')"></div>';

        comodo.innerHTML = content;
    } */
    render() {
        return (
            [
                // <Breadcrumbs key={1} url={this.props} />
                <footer key={2} className="global-footer tw-m-auto">
                    <div className="container-footer tw-container tw-px-5">
                        <div className="navigation tw-border-t tw-border-black tw-py-[50px]">

                            <div className="tw-flex tw-flex-col tw-items-center tw-self-center lg:tw-mr-10">
                                <div className="logo tw-flex tw-justify-center">
                                    <Link to="/" title="Antena 1 - A rádio online mais ouvida do Brasil" onClick={handleNavigate}>
                                        <img
                                            src="https://a1media.antena1.com.br/image/misc/logo/a1-logo.svg"
                                            alt="Antena 1 - A rádio online mais ouvida do Brasil"
                                            title="Antena 1 - A rádio online mais ouvida do Brasil"
                                            className="tw-w-44 tw-h-20"
                                        />
                                    </Link>
                                </div>

                                <Frequencys />
                            </div>

                            {footerList.map((data, i) => (
                                <MenuFooter
                                    key={data.category}
                                    listMenu={data.items}
                                    titleMenu={data.category}
                                    pathname={this.props.pathname}
                                    defaultOpen={i === 0}
                                />
                            ))}

                            <div className="footerContact lg:tw-ml-10">
                                <div className="tw-flex tw-flex-col">
                                    <p>Atendimento a ouvintes</p>
                                    <a href="tel:+551130342224">
                                        <FontAwesomeIcon className="icon-contact fa-lg" icon={faPhoneAlt} color="black" />
                                        +55 (11) 3034-2224
                                    </a>
                                    <a href="https://api.whatsapp.com/send?phone=5511970764000">
                                        <FontAwesomeIcon className="icon-contact fa-lg" icon={faWhatsapp} color="black" />
                                        +55 (11) 97076-4000
                                    </a>
                                </div>
                                <br />
                                <div>
                                    <p>Exclusivo Corporativo e Comercial</p>
                                    <a href="tel:+551130388000">
                                        <FontAwesomeIcon className="icon-contact fa-lg" icon={faPhoneAlt} color="black" />
                                        +55 (11) 3038-8000
                                    </a>
                                </div>
                            </div>

                            {/*
                                    <div className="nav">
                                        <div className="ads">

                                        <div className="embed-player tw-w-100">
                                            <Button title="Incorpore Nosso Player no seu site " to="/incorporar-player">
                                                Incorpore Nosso Player no seu site
                                                {' '}
                                                <FontAwesomeIcon icon={faCode} width="16" />
                                            </Button>
                                        </div>

                                        <div className="downloads-app tw-w-100">
                                            <Button to="/aplicativos" title="Baixar no Google Play, Apple Store, Amazon Appstore e Amazon Alexa">
                                                <img src={appsIcon} alt="Icone baixar no Google Play, Apple Store, Amazon Appstore e Amazon Alexa" />
                                            </Button>
                                        </div>
                                    </div>
                                    </div>
                                */}


                        </div>

                        <button
                            type="button"
                            className="tw-min-h-11 tw-underline tw-text-sm tw-text-gray-800"
                            onClick={() => window.dispatchEvent(new Event('a1-consent-open'))}
                        >
                            Preferências de cookies
                        </button>

                        <div className="available-footer">
                            <p>Disponível em</p>
                            <ul>
                                {footerAvailablePlatforms.map((item) => (
                                    <li key={item.icon}>
                                        <a href={item.link} target="_blank" rel="noreferrer">
                                            <img src={`https://a1media.antena1.com.br/image/misc/availablePlatforms/${item.icon}`} alt={item.title} title={item.title} />
                                        </a>
                                    </li>
                                ))}

                            </ul>
                        </div>
                        {/* <div className="seals tw-flex tw-items-center tw-justify-around sm:tw-justify-end tw-mt-3">
                            <Button className="sucuri-badge" href="https://monitor19.sucuri.net/m/verify/?r=32fa4816e361f92ae9e9a1bf9bd42b6abf3d3a7455" title="Sucuri Site Verification">
                                <img alt="Sucuri badge" src="/sucuri_badge.png" />
                            </Button>
                            <Button className="sectigo-seal" href="https://www.trustlogo.com/ttb_searcher/trustlogo?v_querytype=W&v_shortname=SECOV&v_search=https://www.antena1.com.br&x=6&y=5" title="Sectigo PremiumSSL Wildcard Verification">
                                <img alt="Sectigo badge" src="/sectigo_trust_seal_lg_140x54.png" />
                            </Button>
                            <Button className="ecolmeia-selo" href="https://ecolmeia.org.br/wp-content/uploads/2019/11/153-Antena-Um-Radiodifus%C3%A3o-Certificado-Ouro.jpg" title="Ecolmeia Selo Verde Gold">
                                <img className="ecolmeia-selo-img" alt="Ecolmeia selo verde gold" src={seloVerdeMini} onMouseEnter={this._ecolmeiaMouseOver} onMouseLeave={this._ecolmeiaMouseOver} />
                            </Button>
                            {this.state.ecolmeiaFull &&
                            <div className="ecolmeia-selo-full">
                                <img className="ecolmeia-selo-img-full" alt="Ecolmeia selo verde gold popup" src={seloVerdeFull} />
                            </div>}
                        </div> */}
                    </div>

                    <div className="information">
                        <div>
                            <span>
                                Rádio Antena 1 &copy; 1975 -
                                {new Date().getFullYear()}
                                . Todos os direitos reservados.
                            </span>
                        </div>
                    </div>
                </footer>,
            ]
        );
    }
}

Footer.propTypes = exact({
    // locked: PropTypes.bool,
    pathname: PropTypes.string,
    // a1LogoUrl: PropTypes.string.isRequired,
    // a1LogoAlt: PropTypes.string.isRequired,
});

export default Footer;
